import i18n from "../../i18n";
import styles from "../styles/HotelSearch.module.scss"

type SelectBoxSortProps = {
  handleSortChange: (sort: string) => void;
}

const SelectBoxSort: React.FC<SelectBoxSortProps> = ({ handleSortChange }) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleSortChange(e.target.value);
  }
  return (
    <>
      <select className={`form-control form-control-sm ml-2 ${styles.selectBoxSort}`} onChange={handleOnChange}>
        <option value='featured'>{i18n.t('stay_packages.hotels.index.sort_by_recommended')}</option>
        <option value='priceAsc'>{i18n.t('stay_packages.hotels.index.sort_by_price_asc')}</option>
        <option value='priceDesc'>{i18n.t('stay_packages.hotels.index.sort_by_price_desc')}</option>
      </select>
    </>
  )
}

export default SelectBoxSort;
